import { BaseError } from "./base-error.js";
export class EntitlementError extends BaseError {
    static code = 'EntitlementError';
    static statusCode = 500;
    constructor(message = 'Entitlement Error', options = {}) {
        super(message, options);
    }
}
